/**
 * Renders a schema section with conditional field visibility.
 */
export function FieldRenderer({ schema, values, onChange, errors = {} }) {
  return (
    <div className="space-y-10">
      {schema.sections.map((section) => (
        <div key={section.id}>
          <h3 className="font-display text-3xl text-navy mb-1">{section.title}</h3>
          {section.description && (
            <p className="text-ink-soft text-[15px] mb-5">{section.description}</p>
          )}
          <div className="grid grid-cols-12 gap-4">
            {section.fields.map((f) => {
              if (f.showIf && !f.showIf(values)) return null;
              const err = errors[f.key];
              return (
                <div key={f.key} className={`col-span-12 md:col-span-${f.span || 12}`}>
                  {f.type === "checkbox" ? (
                    <label className="flex items-start gap-3 cursor-pointer text-[15px] text-ink-soft select-none">
                      <input
                        type="checkbox"
                        checked={!!values[f.key]}
                        onChange={(e) => onChange(f.key, e.target.checked)}
                        className="mt-1 h-4 w-4 accent-[var(--oih-navy)]"
                        aria-invalid={!!err}
                        data-testid={`field-${f.key}`}
                      />
                      <span>
                        {f.label}
                        {f.required && <span className="text-[var(--oih-bronze)] ml-1" aria-hidden="true">*</span>}
                      </span>
                    </label>
                  ) : (
                    <>
                      <label className="field-label" htmlFor={`f-${f.key}`}>
                        {f.label}{f.required && <span className="text-[var(--oih-bronze)] ml-1" aria-hidden="true">*</span>}
                      </label>
                      {f.type === "textarea" ? (
                        <textarea
                          id={`f-${f.key}`}
                          rows={f.rows || 3}
                          className="input-heritage"
                          placeholder={f.placeholder || ""}
                          value={values[f.key] || ""}
                          onChange={(e) => onChange(f.key, e.target.value)}
                          aria-invalid={!!err}
                          data-testid={`field-${f.key}`}
                        />
                      ) : f.type === "select" ? (
                        <select
                          id={`f-${f.key}`}
                          className="input-heritage"
                          value={values[f.key] || ""}
                          onChange={(e) => onChange(f.key, e.target.value)}
                          aria-invalid={!!err}
                          data-testid={`field-${f.key}`}
                        >
                          <option value="">Select…</option>
                          {(f.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
                        </select>
                      ) : (
                        <input
                          id={`f-${f.key}`}
                          type={f.type || "text"}
                          className="input-heritage"
                          placeholder={f.placeholder || ""}
                          value={values[f.key] || ""}
                          onChange={(e) => onChange(f.key, e.target.value)}
                          aria-invalid={!!err}
                          data-testid={`field-${f.key}`}
                        />
                      )}
                      {f.help && <div className="field-help">{f.help}</div>}
                    </>
                  )}
                  {err && (
                    <div className="text-xs text-red-700 mt-1" role="alert" data-testid={`field-error-${f.key}`}>{err}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
